import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowRightIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 19,
	viewBox: "0 0 18 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.67188 2.11719L8.53125 1.25781C8.92188 0.90625 9.50781 0.90625 9.85938 1.25781L17.4766 8.83594C17.8281 9.22656 17.8281 9.8125 17.4766 10.1641L9.85938 17.7812C9.50781 18.1328 8.92188 18.1328 8.53125 17.7812L7.67188 16.9219C7.32031 16.5312 7.32031 15.9453 7.67188 15.5547L12.3984 11.0625H1.1875C0.640625 11.0625 0.25 10.6719 0.25 10.125V8.875C0.25 8.36719 0.640625 7.9375 1.1875 7.9375H12.3984L7.67188 3.48438C7.32031 3.09375 7.28125 2.50781 7.67188 2.11719Z",
		fill: "#1B1C19"
	})
});
export default SvgArrowRightIcon;
